import React, { useEffect, useState } from 'react';
import styles from './WorkFlowChat.module.scss';
import ChatHeader from './components/ChatHeader';
import ChatConsoleView from 'component/organism/chat-console/ChatConsoleView';
import { useBrandingContext } from 'app-context/BrandingsContext';

const WorkFlowChat = ({ isOpen, setIsOpen, botId }) => {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;

  const [isExpanded, setIsExpanded] = useState(false);
  const [startNewChat, setStartNewChat] = useState(false);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const handleStartNewChat = () => {
    setStartNewChat((prev) => !prev);
  };

  useEffect(() => {
    handleStartNewChat();
  }, [botId]);

  return (
    <div
      className={`${styles['chat-sidebar']} ${
        isExpanded ? styles['expanded'] : styles['collapsed']
      }`}
      style={{ background: !isExpanded ? page_ButtonColor : 'white' }}
    >
      <ChatHeader
        onMenuClick={setIsOpen}
        isOpen={isOpen}
        handleExpand={handleExpand}
        onNewChat={handleStartNewChat}
        isExpanded={isExpanded}
        // title={'Try Me'}
        config={{
          exitSvg: 'exit_modal',
          sideSvg: 'bot',
          className: styles['svg-class'],
        }}
      />
      <div
        className={`${styles['chat-body']} ${
          isExpanded ? styles['expanded'] : styles['collapsed']
        }`}
      >
        <ChatConsoleView
          isOpen={isExpanded}
          hasSidebar={false}
          className={styles['chat-console-external']}
          bodyClassName={styles['chat-console-body']}
          bot={botId}
          inputContainerClass={styles['input-chat-container']}
          chattingClassName={styles['chatting-body-class']}
          isWorkFlow
          isExpanded={isExpanded}
          triggerNewConversation={startNewChat}
          isWorkFlowChat={true}
        />
      </div>
    </div>
  );
};

export default WorkFlowChat;
